// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { NumericTextBox } from '@progress/kendo-vue-inputs';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { cellBoolDropdownChange, cellInputChange } from '../filterCommon';
/**
 * @hidden
 */

var ColumnMenuFilterCellVue2 = {
  props: {
    field: String,
    filterType: String,
    value: [Object, String, Number, Date, Boolean],
    operator: String,
    operators: Array,
    booleanValues: Array
  },
  // @ts-ignore
  emits: {
    change: null,
    filtercellfocus: null
  },
  methods: {
    handleFocus: function handleFocus(e) {
      this.$emit('filtercellfocus', e);
    },
    triggerChange: function triggerChange(filter) {
      this.$emit('change', filter);
    },
    inputChange: function inputChange(value, e) {
      var filter = cellInputChange(value, e, this.$props);
      this.triggerChange(filter);
    },
    boolDropdownChange: function boolDropdownChange(value, e) {
      var filter = cellBoolDropdownChange(value.value.operator, e);
      this.triggerChange(filter);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        filterType = _a.filterType,
        value = _a.value,
        booleanValues = _a.booleanValues;

    switch (filterType) {
      case 'numeric':
        return (// @ts-ignore
          h(NumericTextBox, {
            value: value,
            attrs: this.v3 ? undefined : {
              value: value
            },
            onChange: function onChange(e) {
              _this.inputChange(e.value, e.event);
            },
            on: this.v3 ? undefined : {
              "change": function onChange(e) {
                _this.inputChange(e.value, e.event);
              }
            }
          })
        );

      case 'date':
        return (// @ts-ignore
          h(DatePicker, {
            value: value,
            attrs: this.v3 ? undefined : {
              value: value
            },
            onFocus: this.handleFocus,
            on: this.v3 ? undefined : {
              "focus": this.handleFocus,
              "change": function change(e) {
                _this.inputChange(e.value, e.event);
              }
            },
            onChange: function change(e) {
              _this.inputChange(e.value, e.event);
            }
          })
        );

      case 'boolean':
        var noFilterSet_1 = function noFilterSet_1(filter) {
          return filter === null || filter === undefined;
        };

        return (// @ts-ignore
          h(DropDownList, {
            onChange: this.boolDropdownChange,
            on: this.v3 ? undefined : {
              "change": this.boolDropdownChange
            },
            value: booleanValues.find(function (item) {
              return item.operator === (noFilterSet_1(value) ? '' : value);
            }),
            attrs: this.v3 ? undefined : {
              value: booleanValues.find(function (item) {
                return item.operator === (noFilterSet_1(value) ? '' : value);
              }),
              "data-items": booleanValues,
              textField: "text"
            },
            "data-items": booleanValues,
            textField: "text"
          })
        );

      default:
        return h("span", {
          "class": "k-textbox k-input k-input-md k-rounded-md k-input-solid"
        }, [h("input", {
          "class": "k-input-inner",
          value: this.v3 ? value || '' : null,
          domProps: this.v3 ? undefined : {
            "value": value || ''
          },
          onInput: function onInput(e) {
            _this.inputChange(e.target.value, e);
          },
          on: this.v3 ? undefined : {
            "input": function onInput(e) {
              _this.inputChange(e.target.value, e);
            }
          }
        })]);
    }
  }
};
/**
 * @hidden
 */

var ColumnMenuFilterCell = ColumnMenuFilterCellVue2;
export { ColumnMenuFilterCell, ColumnMenuFilterCellVue2 };